var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66017 4.32061C2.67767 4.14449 2.61175 3.97076 2.48342 3.85255L1.17675 2.2406V2H5.23558L8.37275 9.04184L11.1307 2H15V2.2406L13.8823 3.33732C13.7861 3.41255 13.7382 3.53613 13.7581 3.65852V11.7171C13.7382 11.8389 13.7861 11.9625 13.8823 12.0377L14.9737 13.1344V13.375H9.48342V13.1344L10.6145 12.0108C10.7253 11.8974 10.7253 11.8639 10.7253 11.6902V5.17674L7.58175 13.3487H7.15708L3.49667 5.17674V10.6538C3.46633 10.8836 3.541 11.1159 3.69908 11.2819L5.16967 13.1075V13.3487H1V13.1075L2.47058 11.2819C2.62808 11.1153 2.69808 10.8818 2.66017 10.6538V4.32061Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedium);
export default __webpack_public_path__ + "static/media/ic-medium.24c0ab9f739ff5c224add5e799f784d3.svg";
export { ForwardRef as ReactComponent };